//Passkey events
export const passkeyCreationStarted = 'passkeyCreationStarted';
export const passkeyCreated = 'passkeyCreated';

//user events 
export const currentUserLogged = 'currentUserLogged';